import React, { Component } from 'react';
import Page from '../../components/Page';
import { Icon, Segment, Form, Table } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';
import moment from 'moment';
import { log } from '../../util/api';
import { getContactLists, getContactListPage, uploadContactList } from '../../util/contacts';

const KEY = 'validationCheckList';

class Contacts extends Component {
	phoneToDelete = null;
	state = {
		loading: true,
		saveButton: 'add',
		ex_file: '',
	};
	componentDidMount() {
		this.getList();
	}
	// Son yüklenen listenin ilk 5000 kişisi (kontrol en fazla 5000 numara ile yapılıyor).
	async getList() {
		try {
			let lists = await getContactLists(KEY);
			let page = lists.length ? await getContactListPage(lists[0].id, { limit: 5000 }) : { data: [] };
			this.setState({ list: page.data, loading: false });
		} catch (error) {
			this.setState({ loading: false });
		}
	}

	fileUpload(file) {
		if (!file) return;
		this.setState({ loadingBtn: true, message: false, uploadError: null });
		uploadContactList(file, KEY, true)
			.then((data) => {
				this.setState({ loadingBtn: false, message: !!data.success, uploadError: data.success ? null : data.error });
				this.getList();
			})
			.catch((err) => this.setState({ loadingBtn: false, uploadError: err.message }));
	}
	handleFileInput = (e) => {
		let file = e.target.files[0];
		e.target.value = '';
		this.fileUpload(file);
	};
	validNumbers() {
		let { list } = this.state;
		this.setState({ validBtn: true });
		let contacts = _.map(
			_.filter(list, (o, i) => i < 5000),
			(it) => it.full_mobile_number
		);
		fetch('https://micro.yapaytech.com/api/collectactionopenapi/wvalidation', {
			method: 'post',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ data: { blocking: 'wait', contacts } }),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let result = data.result;
				_.map(result, (it, i) => (it.user_id = (list[i] && list[i].user_id) || ''));
				this.postLog(result);
				this.setState({ validBtn: false });
			});
	}
	async postLog(data) {
		let { product, user } = this.props;
		let pid = product.id;
		let uid = user.id;
		await log('/live/groupMessageLog/add', { pid, uid, log: { date: moment().format('DD-MM-YYYY HH:mm'), data, type: 'valid' } });
	}
	render() {
		const { t } = this.props;
		let { loadingBtn, message, uploadError, list } = this.state;
		if (this.state.loading) {
			return <Page.Loader />;
		} else {
			return (
				<Segment>
					<div style={{ padding: '10px', width: '100%' }}>
						<h3>
							<Icon name="whatsapp" />
							{t('contacts')}
						</h3>
						<Form>
							<Form.Group style={{ display: 'flex', justifyContent: 'center' }}>
								<Form.Button color="green" loading={this.state.validBtn} onClick={() => this.validNumbers()}>
									Kontrol Et
								</Form.Button>
								<div>
									<Form.Field style={{ display: 'flex', marginBottom: '10px' }}>
										<div className="image-upload" style={{ margin: 'auto' }}>
											<label htmlFor="file-input" className={`ui blue icon left labeled button ${loadingBtn ? 'loading' : null}`}>
												{t('upload')}
												<Icon name="upload" style={{ cursor: 'pointer' }}></Icon>
											</label>
										</div>

										<input
											id="file-input"
											type="file"
											accept=".xlsx, .xls, .csv"
											style={{ display: 'none' }}
											onChange={(e) => {
												this.handleFileInput(e);
											}}
										/>
									</Form.Field>
									{message ? <p style={{ textAlign: 'center' }}>{t('messageExcelSuccess')}</p> : null}
									{uploadError ? <p style={{ textAlign: 'center', color: 'red' }}>{uploadError}</p> : null}
								</div>
							</Form.Group>
						</Form>
					</div>
					<Table>
						<Table.Header>
							<Table.Row>
								<Table.HeaderCell>{'full_mobile_number'}</Table.HeaderCell>
								<Table.HeaderCell>{'user_id'}</Table.HeaderCell>
							</Table.Row>
						</Table.Header>
						<Table.Body>
							{_.map(list, (it, i) => (
								<Table.Row key={i}>
									<Table.Cell>{it.full_mobile_number}</Table.Cell>
									<Table.Cell>{it.user_id}</Table.Cell>
								</Table.Row>
							))}
						</Table.Body>
					</Table>
				</Segment>
			);
		}
	}
}

const stateToProps = (state) => ({
	access: state.access,
	location: state.router.location,
	product: state.product.live,
	user: state.access.user.loggedUserObj,
});

export default connect(stateToProps)(withTranslation()(Contacts));
